module.exports = __webpack_public_path__ + "static/1-41979698a877aca923434b10b0ac5b86.jpg";